export default __webpack_public_path__ + "45c12fbf3380076f0a7ba39552a4e850.png";